import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Settings } from 'lucide-react';

const ProductionSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { fetchSettings(); }, []);
  const fetchSettings = async () => {
    try { const r = await api.get('/production/settings'); setSettings(r.data); }
    catch(e) { console.error(e); } finally { setLoading(false); }
  };

  const toggleSetting = async (key) => {
    const updated = { ...settings, [key]: !settings[key] };
    setSettings(updated);
    setSaving(true);
    try { await api.put('/production/settings', updated); }
    catch (err) { alert(err.response?.data?.detail || 'Failed'); setSettings(settings); }
    finally { setSaving(false); }
  };

  const toggleItems = [
    { key: 'assembly_enabled', label: 'Assembly Module', desc: 'Enable assembly tracking for products that are composed of sub-assemblies. When ON, users can define assembly BOMs and track assembly production.' },
    { key: 'cycle_tracking_enabled', label: 'Cycle Time Tracking', desc: 'Track ideal vs actual cycle times per machine per product. Enables OEE calculations and identifies bottleneck operations.' },
    { key: 'downtime_tracking_enabled', label: 'Downtime Tracking', desc: 'Log and categorize machine downtime events (mechanical, electrical, material, planned maintenance). Feeds into availability metrics.' },
    { key: 'scrap_recycle_enabled', label: 'Scrap & Recycle', desc: 'Enable scrap collection and recycling workflows. Track virgin-to-recycled material ratios and batch traceability through recycling loops.' },
  ];

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading settings...</div>;
  if (!settings) return <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-tertiary)' }}>Unable to load settings</div>;

  return (
    <div data-testid="production-settings-page">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Production Settings</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-tertiary)', fontSize: '13px' }}>Configure production module feature toggles</p>
        </div>
        {saving && <span className="badge badge-info">Saving...</span>}
      </div>

      <div style={{ maxWidth: '680px' }}>
        {toggleItems.map(item => (
          <div key={item.key} className="card mb-4" data-testid={`setting-${item.key}`}>
            <div className="flex items-center justify-between">
              <div style={{ flex: 1 }}>
                <div className="flex items-center gap-2" style={{ marginBottom: '4px' }}>
                  <Settings size={16} color="var(--text-secondary)" />
                  <span style={{ fontWeight: 600, fontSize: '15px' }}>{item.label}</span>
                </div>
                <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-secondary)', lineHeight: '1.5' }}>{item.desc}</p>
              </div>
              <button
                onClick={() => toggleSetting(item.key)}
                className="btn btn-sm"
                data-testid={`toggle-${item.key}`}
                style={{
                  minWidth: '64px',
                  background: settings[item.key] ? '#059669' : 'var(--bg-surface-alt)',
                  color: settings[item.key] ? '#fff' : 'var(--text-secondary)',
                  border: `1px solid ${settings[item.key] ? '#059669' : 'var(--border-default)'}`,
                  fontWeight: 600,
                  marginLeft: '16px'
                }}
              >
                {settings[item.key] ? 'ON' : 'OFF'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductionSettings;
